import React, { useEffect, useRef, useState } from "react"
import clsx from "clsx"
import PhoneField from "@ecom/ui/components/PhoneField/PhoneField"
import { WrapperDataLayer } from "./WrapperDataLayer"
import * as styles from "./fields.module.scss"
import CheckedGreenIcon from "../icons/CheckedGreen"
import Plus25Icon from "../icons/Plus25"
import { TPhoneField } from "../../types"

export const PhoneFieldTwoMask = ({
  touched,
  error,
  isGreenApprove,
  handleBlur,
  name,
  inputsColor = "white",
  isFioFieldValidate,
  onPaste,
  focus,
  setFocus,
  variant,
  ...restProps
}: TPhoneField) => {
  const isChanged = restProps.value.length > 1
  const [isFirstClick, setIsFirstClick] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  let greenIcon: JSX.Element | null = null

  if (!error && isFirstClick) {
    greenIcon = <CheckedGreenIcon variant={variant} />
  } else if (isFioFieldValidate || isFirstClick) {
    greenIcon = <Plus25Icon isFocusing={focus} variant={variant} />
  }

  const handleFocus = () => {
    setFocus(true)
    setIsFirstClick(true)
  }

  useEffect(() => {
    if (focus && inputRef.current) {
      inputRef.current.focus()
    }
  }, [focus])

  return (
    <WrapperDataLayer
      isChanged={isChanged}
      touched={touched}
      error={touched ? error || "" : ""}
      focus={focus}
      name={name}
    >
      <div onBlur={() => setFocus(false)} onFocus={handleFocus} className={styles.fieldWrapper}>
        <PhoneField
          {...restProps}
          inputRef={inputRef}
          InputProps={{
            classes: {
              notchedOutline: styles.notchedOutline,
              root: clsx(styles.field, styles[inputsColor], variant && styles[variant]),
            },
            endAdornment: <>{isGreenApprove && greenIcon}</>,
            onPaste,
          }}
          onBlur={handleBlur}
          placeholder="Телефон"
          helperText={touched ? error : ""}
          error={touched && !!error}
          fullWidth
        />
      </div>
    </WrapperDataLayer>
  )
}
